import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '../store/authStore.jsx';
import LoadingSpinner from './LoadingSpinner.jsx';

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, loading, checkAuth } = useAuthStore();

  // 컴포넌트 마운트 시 인증 상태 확인
  React.useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  // 로딩 중일 때
  if (loading) {
    return (
      <div className="loading-container">
        <LoadingSpinner size="large" text="인증 확인 중..." />
      </div>
    );
  }

  // 로그인되지 않은 경우 로그인 페이지로 리다이렉트
  if (!isAuthenticated) {
    return (
      <Navigate 
        to={`/login?returnUri=${encodeURIComponent(location.pathname + location.search)}`} 
        replace 
      />
    );
  }

  // 인증된 경우 children 렌더링
  return children;
};

export default PrivateRoute;